<template>

  <div class="header clearfix" js-header>
    <div class="col-xs-5">
      <div class="header-filter">
      <label class="checkbox-inline" v-for="catalog in categories" track-by="$index">
        <input type="checkbox" @change="fetchData()" v-model="search" :value="catalog"> {{catalog}}
      </label>
      <label class="checkbox-inline"  track-by="$index">
        <input type="checkbox" @change="fetchData()" v-model="searchFilled" value="yes"> 已报满
      </label>
      <label class="checkbox-inline"  track-by="$index">
         <input type="checkbox" @change="fetchData()" v-model="searchFilled" value="no"> 未报满
      </label>
      <label class="checkbox-inline"  track-by="$index">
        <input type="checkbox" @change="fetchData()" v-model="searchHistory"
        :true-value="'yes'"
        :false-value="''"> 历史记录
      </label>
      <label class="checkbox-inline"  track-by="$index">
        <input type="checkbox" @change="fetchData()" v-model="thisWeek"
        :true-value="'yes'"
        :false-value="''"> 本周
      </label>
      <span class="checkbox-inline">选择城市：</span>
      <select v-model="searchCity" @change="fetchData()">
        <option v-for="(key, val) in cityOption" track-by="$index" :value="val">{{val}}</option>
      </select>
      </div>
    </div>

    <div class="col-xs-7 pull-right">
      <div class="header-temp" v-d-drop="{type: 'temp', list: temp}">
        <div class="giver" v-d-drag="{type: 'temp', list: temp, item: item}" v-for="item in temp" track-by="$index">
          {{item.name}} {{item.mobile}}
        </div>
      </div>
    </div>
  </div>
  <div class="ab-container" js-ab-container>
    <div class="panel-container" js-scroll-parent>
      <div class="panel-item panel panel-info" v-for="item in list" track-by="$index">
        <div class="panel-heading d-panel-heading">
          <!-- <button type="button" class="btn btn-info btn-xs pull-right glyphicon glyphicon-envelope"></button> -->
          <div><span class="text-danger">[{{item.alias}}]</span> {{item.name}} {{item.start}}</div>
          <div>[集合信息]{{item.meetTime}} {{item.meetPlace}}</div>
          <div>[是否定制]{{tripIsCustom[item.isCustom]}}</div>
        </div>
        <div class="d-scroll" js-scroll>
          <table class="table table-bordered table-condensed table-center" v-for="roleGroup in item.roles" track-by="$index">
            <caption class="text-center">
              {{roleGroup.role}}
              <span v-if="roleGroup.role === '领队' || roleGroup.role === 'ST志愿者' || roleGroup.role === 'CE大活动志愿者'" class="text-danger" v-show="roleGroup.openTime">抢单时间 {{roleGroup.openTime}}
                <button class="btn btn-xs btn-default" @click="showChangeOpenTime(roleGroup)">改</button>
              </span>
            </caption>
            <thead>
              <tr>
                <th></th>
                <th>
                  {{roles[roleGroup.role]}} {{roleGroup.leaders.length}}/{{roleGroup.size}}人
                  <button type="button" class="btn btn-success btn-xs" @click="showChangeNum(roleGroup)">改</button>
                  <button type="button" class="btn btn-danger btn-xs" @click="click(removeDemand)($event, {
                    list: item.roles,
                    item: roleGroup
                  })">删</button>
                </th>
                <th v-if="roleGroup.role === '领队' || roleGroup.role === 'ST志愿者' || roleGroup.role === 'CE大活动志愿者'">组长</th>
              </tr>
            </thead>
            <tbody v-d-drop="{type: 'trip', list: roleGroup.leaders, role: roleGroup.role, tripId: item.tripId}">
              <tr v-for="leader in roleGroup.leaders" track-by="$index">
                <td><button type="button" class="close" @click="click(remove)($event, {
                  list: roleGroup.leaders,
                  item: leader
                })">&times;</button></td>
                <td>
                  <span class="giver" v-d-drag="{
                    type: 'trip',
                    list: roleGroup.leaders,
                    item: leader
                  }">
                    {{leader.name}} {{leader.mobile}}
                  </span>
                </td>
                <td v-if="roleGroup.role === '领队' || roleGroup.role === 'ST志愿者' || roleGroup.role === 'CE大活动志愿者'">
                  <input type="checkbox"
                  @change="changeGreatLeader({ list: roleGroup.leaders, item: leader, tripId: item.tripId })"
                  v-model="leader.greatLeader"
                  :true-value="1"
                  :false-value="0">
                </td>
              </tr>
              <tr>
                <td></td>
                <td class="add" @click="showAdd({
                  tripId: item.tripId,
                  list: roleGroup.leaders,
                  role: roleGroup.role,
                  demandId: roleGroup.demandId
                })">
                  +
                </td>
                <td v-if="roleGroup.role === '领队'">
                </td>
              </tr>
            </tbody>
            </table>
        </div>
      </div>
    </div>
    <aside :show.sync="isShowLeader" placement="right" header="-" :width="450">
      <form>
        <div class="form-group">
          <input type="text" class="form-control" v-model="leaderName" debounce="500" placeholder="search">
        </div>
      </form>
      <table class="table table-condensed">
        <tr v-for="item in leaders | filterBy leaderName in 'name' 'nickName'" track-by="$index">
          <td>
            <button class="btn btn-xs btn-success" type="button" @click="add({
                list: [],
                item: {leaderId: item.id}
              },
              selectTrip)">排</button>
          </td>
          <td>
            {{item.name}}({{item.nickName}})
          </td>
          <td>
            {{item.sex}} {{item.mobile}}
          </td>
          <td>
            <a v-link="'/giver/' + item.id" @click="isShowLeader=false" class="btn-link">管理</a>
          </td>
        </tr>
      </table>
    </aside>
    <aside :show.sync="isShowChangeNum" placement="right" header="修改人数" :width="450">
      <form>
        <div class="form-group">
          <label class="control-label">修改人数</label>
          <input type="text" class="form-control" v-model="changeNumForm.size">
        </div>
        <!--
        <div class="form-group">
          <label class="control-label">发送消息</label>
          <div>
            <label class="radio-inline">
              <input type="radio" v-model="changeNumForm.messageLevel" :value="5">立即发送
            </label>
            <label class="radio-inline">
              <input type="radio" v-model="changeNumForm.messageLevel" :value="0">稍后发送
            </label>
          </div>
        </div>
        -->
        <div class="from-group text-center">
          <button class="btn btn-primary" type="button" @click="click(changeNum)($event)">修改</button>
        </div>
      </form>
    </aside>
    <aside :show.sync="isShowChangeOpenTime" placement="right" header="修改抢单时间" :width="450">
      <form>
        <div class="form-group">
          <label class="control-label">修改抢单时间</label>
          <input type="text" class="form-control" data-field="datetime" v-model="changeOpenTimeForm.openTime">
        </div>
        <div class="from-group text-center">
          <button class="btn btn-primary" type="button" @click="click(changeOpenTime)($event)">修改</button>
        </div>
      </form>
    </aside>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { aside } from 'vue-strap'
  import config from '../libs/config'
  import utils from '../libs/utils'

  window.$ = $

  export default {
    components: {
      aside
    },
    ready () {
      $(window).on('resize', this.calHeight)

      $('[js-ab-container]').on('mousewheel', function (e) {
        if ($(e.toElement).parents('.panel-item').length) {
          return
        }
        let { deltaX, deltaY } = e.originalEvent
        if (deltaY !== 0 && deltaX === 0) {
          this.scrollLeft -= 30 * deltaY
          return
        }
      })
    },
    beforeDestroy () {
      $(window).off('resize')
      $('[js-ab-container]').off('mousewheel')
    },
    data () {
      return {
        categories: config.categories,
        roles: config.roles,
        tripIsCustom: config.tripIsCustom,
        list: [],
        drag: null,
        selectTrip: null,
        changeNumTemp: null,
        changeOpenTimeTemp: null,
        isShowLeader: false,
        isShowChangeOpenTime: false,
        isShowChangeNum: false,
        search: [],
        temp: [],
        changeNumForm: {size: null, messageLevel: 0},
        changeOpenTimeForm: {},
        leaders: [],
        searchFilled: [],
        searchHistory: '',
        thisWeek: '',
        searchCity: '全部',
        leaderName: '',

        cityOption: [
          '全部',
          '北京',
          '上海'
        ]
      }
    },
    watch: {
      isShowLeader (val) {
        if (!val) {
          this.leaderName = ''
        }
      }
    },
    methods: {
      calHeight () {
        let $header = $('[js-header]')
        let max = $(window).height() - $header.offset().top - $header.height() - 100
        $('[js-scroll]')
          .each(function (elem) {
            $(this).css('max-height', max)
          })
      },
      fetchData () {
        let params = Object.assign({
          catalog: this.search.join(','),
          filled: this.searchFilled.join(','),
          history: this.searchHistory,
          thisWeek: this.thisWeek,
          city: this.searchCity
        })
        return this.$http.get(`${config.apiM}/product/giver/work`, params)
          .then(({data}) => {
            this.$set('list', data)
          })
      },
      showChangeOpenTime (role) {
        this.changeOpenTimeTemp = role
        this.changeOpenTimeForm = { openTime: role.openTime }
        this.isShowChangeOpenTime = true
      },
      changeOpenTime () {
        return this.$http.put(`${config.apiM}/product/giver/demand/${this.changeOpenTimeTemp.demandId}/time`, this.changeOpenTimeForm)
          .then(() => {
            this.changeOpenTimeTemp.openTime = this.changeOpenTimeForm.openTime
            this.isShowChangeOpenTime = false
          })
      },
      showChangeNum (role) {
        this.changeNumTemp = role
        this.changeNumForm = {size: role.size, messageLevel: 0}
        this.isShowChangeNum = true
      },
      changeNum () {
        // let demandId = this.changeNumTemp.demandId
        return this.$http.put(`${config.apiM}/product/giver/demand/${this.changeNumTemp.demandId}`, this.changeNumForm)
          .then(() => {
            this.changeNumTemp.size = this.changeNumForm.size
            this.isShowChangeNum = false
          })
      },
      removeDemand ({ list = [], item = {} }) {
        if (window.confirm('确定删除?')) {
          return this.$http.delete(`${config.apiM}/product/giver/demand/${item.demandId}`)
            .then(() => {
              list.$remove(item)
            })
        }
      },
      showAdd (trip) {
        this.isShowLeader = true
        this.selectTrip = trip
        let url
        let params = {}
        if (trip.role === '领队') {
          url = `${config.apiWe}/product/giver/work/${trip.demandId}/Leader`
        } else {
          url = `${config.api}/giver/leader`
          params.abilities = trip.role
        }
        this.leaders = []
        this.$http.get(url, params)
          .then(function ({data}) {
            this.leaders = data
          })
      },
      add (from, to) {
        let data = {
          tripId: to.tripId,
          leaderId: from.item.leaderId,
          role: to.role
        }
        return this.$http.post(`${config.apiM}/product/giver/work`, data)
          .then(({data: workId}) => {
            this.fetchData()
            /*
            to.list.push(Object.assign({}, from.item, {workId}))
            from.list.$remove(from.item)
            */
            from.list.$remove(from.item)
          })
      },
      remove ({list, item}) {
        if (window.confirm('确认删除？')) {
          return this.$http.delete(`${config.apiM}/product/giver/work/${item.workId}`)
            .then(() => {
              list.$remove(item)
            })
        }
        return Promise.resolve()
      },
      change (from, to) {
        let data = {
          tripId: to.tripId
        }
        return this.$http.put(`${config.apiM}/product/giver/work/${from.item.workId}`, data)
          .then(() => {
            from.list.$remove(from.item)
            to.list.push(from.item)
          })
      },
      changeGreatLeader ({list = [], item = {}, tripId}) {
        let data = {
          tripId,
          greatLeader: item.greatLeader
        }

        return this.$http.put(`${config.apiM}/product/giver/work/${item.workId}`, data)
          .then(() => {
            list.forEach((leader) => {
              if (leader !== item) {
                leader.greatLeader = 0
              }
            })
            this.fetchData()
          }, () => {
            item.greatLeader = 0
          })
      },
      click: utils.click
    },
    directives: {
      dDrag: {
        params: ['data'],
        bind () {
          $(this.el).attr('draggable', true)
          $(this.el).on('dragstart', (e) => {
            this.vm.drag = this.$_val
          })
        },
        update (val) {
          this.$_val = val
        },
        unbind () {
          $(this.el).off()
        }
      },
      dDrop: {
        bind () {
          $(this.el).on('dragenter dragover', (e) => {
            e.preventDefault()
            e.originalEvent.dataTransfer.dropEffect = 'move'
          })
          $(this.el).on('drop', (e) => {
            e.preventDefault()
            e.stopPropagation()

            let drop = this.$_val
            let drag = this.vm.drag

            let remove = () => {
              this.vm.remove(drag)
                  .then(() => {
                    drop.list.push(drag.item)
                  })
            }

            let change = () => {
              this.vm.change(drag, drop)
            }

            let add = () => {
              this.vm.add(drag, drop)
            }

            if (drag.list === drop.list) {
              return false
            }

            if (drag.type === 'trip') {
              if (drop.type === 'temp') {
                remove()
              } else if (drop.type === 'trip') {
                change()
              }
            } else if (drag.type === 'temp') {
              if (drop.type === 'trip') {
                add()
              }
            }
          })
        },
        update (val) {
          this.$_val = val
        }
      }
    },
    route: {
      data () {
        return this.fetchData()
          .then(this.calHeight)
      }
    }
  }
</script>

<style scoped>
  .d-scroll {
    overflow: auto;
  }
  .ab-container {
    position: absolute;
    top: 150px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: hidden;
  }
  .header {
    padding: 0 15px;
    margin-bottom: 5px;
    position: fixed;
    left: 0;
    right: 0;
  }
  .panel-container {
    white-space: nowrap;
    padding: 15px;
  }
  .panel-item {
    vertical-align: top;
    display: inline-block;
    margin-left: 15px;
    width: 275px;
    overflow-y: auto;
    position: relative;
    white-space: normal;
  }
  .panel-item:first-child {
    margin-left: 0;
  }
  .d-panel-heading {
    /*position: absolute;
    right: 0;
    left: 0;*/
    padding: 10px;
  }
  .d-panel-body {
    overflow: auto;
    padding: 10px;
  }
  .trip-item {
    margin-top: 10px;
    padding: 10px;
    border-bottom: 4px solid #eee;
  }
  .giver-row {
    margin-bottom: 4px;
  }
  .l-del {
    float: left;
    width: 40px;
    min-height: 1px;
  }
  .giver {
    font-size: 12px;
    border-radius: 3px;
    /*width: 167px;*/
    color: #15c;
    /*background-color: #337ab7;*/
    padding: 4px;
    display: inline-block;
  }
  .l-giver-wraper {
    float: left;
    width: 166px;
  }
  .l-radio {
    float: right;
    width: 50px;
  }
  [draggable] {
    user-select: none;
  }
  .nowrap {
    white-space: nowrap;
  }
  .header-filter,
  .header-temp {
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 3px;
    padding: 10px;
    overflow: auto;
  }

  .header-temp {
    height: 80px;
    position: relative;
    bottom: 20px
  }
  .table-center {
    width: 100%;
  }
  .table-center th,
  .table-center td {
    text-align: center;
    vertical-align: middle;
  }
  .add {
    border: 1px solid #ddd;
    cursor: pointer;
  }
</style>



/** WEBPACK FOOTER **
 ** Arrange.vue?600347b2
 **/